import { useContext } from "react"
import { UserContext } from "../../context/UserContext.js"
import { Login } from "../account/login.jsx"
import { MainMenu } from "../navs/MainMenu.jsx"
import MainBottomNavigation from "../navs/Bottom.Navigation.jsx"
import useWindowDimensions from "../../util/isMobile.js"

export const MainLoggedInLayout = ({ children }) => {
    const { userDetails } = useContext(UserContext)
    const { width } = useWindowDimensions()
    const desktop = width > 900

    const user = !!(userDetails?.id || userDetails?.token)

    if (!user) {
        return (
            <div style={{ minHeight: '100vh', background: '#f6f7fb' }}>
                <div style={{
                    maxWidth: desktop ? 860 : '100%',
                    margin: '0 auto',
                    padding: desktop ? '32px 24px' : '12px 10px',
                    paddingBottom: 96,
                    boxSizing: 'border-box',
                }}>
                    {children}
                </div>
                <div style={{ position: 'fixed', bottom: 0, width: '100%', zIndex: 100 }}>
                    <Login />
                </div>
            </div>
        )
    }

    return (
        <div style={{
            display: 'flex',
            minHeight: '100vh',
            background: '#f6f7fb',
        }}>
            {/* Sidebar — desktop only */}
            {desktop && (
                <aside style={{
                    width: 240,
                    flexShrink: 0,
                    position: 'sticky',
                    top: 0,
                    height: '100vh',
                    overflowY: 'auto',
                    background: '#fff',
                    borderRight: '1px solid #ececf0',
                    display: 'flex',
                    flexDirection: 'column',
                    zIndex: 10,
                }}>
                    {/* Brand strip */}
                    <div style={{
                        height: 4,
                        background: 'linear-gradient(90deg,#E40303,#FF8C00,#FFED00,#008026,#24408E,#732982)',
                        flexShrink: 0,
                    }} />
                    <MainMenu />
                </aside>
            )}

            {/* Main content */}
            <main style={{
                flex: 1,
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
                paddingBottom: desktop ? 0 : 72,
            }}>
                <div style={{
                    flex: 1,
                    width: '100%',
                    maxWidth: desktop ? 860 : '100%',
                    margin: '0 auto',
                    padding: desktop ? '32px 24px' : '12px 10px',
                    boxSizing: 'border-box',
                }}>
                    {children}
                </div>
            </main>

            {/* Bottom nav — mobile only */}
            {!desktop && (
                <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 100 }}>
                    <MainBottomNavigation />
                </div>
            )}
        </div>
    )
}
